<template>
  <div id="logged-tab-user-info" :class="{active: isActiveSidebar}">
    <div class="user-info-container" v-on:click="handleClick">
      <div class="user-info">
        <div class="avatar">
          <img :src="userInfo.avatar" alt="" title="">
        </div>
        <div class="user-info-data">
          <div class="user-info-logged">Zalogowany jako:</div>
          <div class="user-info-name">{{ userInfo.userFirstName }} {{ userInfo.userLastName }}</div>
        </div>
      </div>
      <div class="nav-icon">&rsaquo;</div>
    </div>
    <div class="exsertile-tab">
      <a :href="urlAccountInfo">Twój profil</a>
      <a :href="urlAccountLogout">Wyloguj</a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'UserInfo',
  computed: {
    ...mapGetters([
      'userInfo'
    ])
  },
  data () {
    return {
      isActiveSidebar: false,
      urlAccountInfo: process.env.VUE_APP_AUTH_HOST + process.env.VUE_APP_AUTH_DIETITIAN_ACCOUNT_INFO,
      urlAccountLogout: process.env.VUE_APP_AUTH_HOST + process.env.VUE_APP_AUTH_DIETITIAN_ACCOUNT_LOGOUT
    }
  },
  methods: {
    handleClick: function () {
      this.isActiveSidebar = !this.isActiveSidebar
    }
  }
}
</script>

<style scoped>
.user-info-data{
  max-width: 170px;
}
.nav-icon {
  color: #A8A8A8;
  font-size: 30px;
  font-weight: 400;
  transform: rotate(0deg);
  -webkit-transition: all .3s ease-in-out;
  -moz-transition: all .3s ease-in-out;
  -o-transition: all .3s ease-in-out;
  transition: all .3s ease-in-out;
  overflow: hidden;
  margin-right: 5px;
}
.active .nav-icon {
  transform: rotate(180deg);
  -webkit-transition: all .3s ease-in-out;
  -moz-transition: all .3s ease-in-out;
  -o-transition: all .3s ease-in-out;
  transition: all .3s ease-in-out;
}
.user-info-container {
  align-items: center;
  cursor: pointer;
  display: flex;
  font-family: 'Roboto-Regular', sans-serif;
  font-size: 13px;
  font-weight: 500;
  justify-content: space-between;
  margin: 12px 0px;
}
.user-info {
  align-items: center;
  display: flex;
}
.user-info-logged {
  color: #A8A8A8;
  letter-spacing: 1px;
  margin-bottom: 5px;
  text-transform: uppercase;
}
.avatar img {
  background-color: transparent;
  border: 4px solid rgba(210, 210, 210, 0);
  border-radius: 48px;
  height: 45px;
  margin: 0 4px;
  -webkit-transition: all .3s ease-in-out;
  -moz-transition: all .3s ease-in-out;
  -o-transition: all .3s ease-in-out;
  transition: all .3s ease-in-out;
  width: 45px;
}
#logged-tab-user-info:hover .avatar img {
  border: 4px solid rgba(210, 210, 210, 0.82);
}
.user-info-name {
  font-size: 15px;
  overflow: hidden;
}
.exsertile-tab {
  position: fixed;
  bottom: 10px;
  left: -200px;
  min-width: 180px;
  background: white;
  box-shadow: 0 5px 10px 0 rgba(0,0,0,0.05);
  z-index: 9999;
  transition: all 0.3s ease-in-out;
}
.active .exsertile-tab {
  left: 255px;
  transition: all 0.3s ease-in-out;
}
.exsertile-tab a {
  display: block;
  padding: 15px;
  color: #000;
  font-weight: 500;
  text-transform: uppercase;
  border-bottom: 1px solid #e4e4e4;
}
.exsertile-tab a:hover {
  background-color: #41cda8;
  color: white;
}
.exsertile-tab a:last-child {
  border-bottom: 0;
}
@media screen and (max-width: 768px) {
  .exsertile-tab a:first-child {
    border-top: 1px solid #e4e4e4;
  }
  .active .exsertile-tab {
    position: unset;
    bottom: unset;
    left: unset;
  }
  .user-info-container {
    display: none;
  }
}
</style>
